export default __webpack_public_path__ + "static/media/role-edit-icon-hover.5e9da559.svg";